// extracted by mini-css-extract-plugin
export default {"list":"SocialLinks_list__jxEqw"};